module.exports = __webpack_public_path__ + "img/silver-medal.b12cf67e.png";